import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse, HttpResponse } from '@angular/common/http';

import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';

import { NotificationToastService } from '@services/index';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private readonly notificationToastService = inject(NotificationToastService);
    private readonly cookieService = inject(CookieService);

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const request = this.getRequest(req);

        return next.handle(request).pipe(
            tap({
                next: event => this.doEvent(req, event),
                error: error => this.doError(req, error)
            })
        );
    }

    private getRequest(req: HttpRequest<any>): HttpRequest<any> {
        const token = this.cookieService.get('token');
        const center = localStorage.getItem('center');
        let myCenter = null;

        if (center) {
            myCenter = JSON.parse(center);
        }

        if (token && myCenter) {
            return req.clone({
                headers: req.headers
                    .append('X-origin', 'appstaff')
                    .append('X-idcenter', myCenter.id ? myCenter.id.toString() : myCenter.center.id.toString())
                    .append('X-accesstoken', token),
            });
        }

        return req.clone({
            headers: req.headers
                .append('X-origin', 'appstaff')
        });
    }

    private doEvent(req: HttpRequest<any>, event: any): void {
        if (event instanceof HttpResponse) {
            const showSuccessMessage = req.headers.get('showSuccessMessage');
            if (showSuccessMessage) {
                this.notificationToastService.showSuccessMessage(showSuccessMessage);
            }
        }
    }

    private doError(req: HttpRequest<any>, err: HttpErrorResponse): void {
        const showErrorMessage = req.headers.get('showErrorMessage');
        if (showErrorMessage == null || showErrorMessage === 'true') {
            if (err instanceof HttpErrorResponse) {
                if (err.error && !(err.error instanceof ProgressEvent) && err.error.errors) {
                    const errors = err.error.errors || err.error;
                    errors.forEach((error: any) => {
                        void this.notificationToastService.add({ description: error.message, icon: 'close-circle-outline', class: 'error-notification' });
                    });
                } else {
                    void this.notificationToastService.add({ description: 'Unknown Error', icon: 'close-circle-outline', class: 'error-notification' });
                }
            } else {
                void this.notificationToastService.add({ description: 'Unknown Error', icon: 'close-circle-outline', class: 'error-notification' });
            }
        }
    }
}
